module.exports = __webpack_public_path__ + "static/customer-support-44c9d86629d308e2470132f966a6e3ac.svg";